'use client';

interface ColorSwatchRowProps {
    label: string;
    colors: string[];
    value: string;
    onChange: (color: string) => void;
}

export default function ColorSwatchRow({ label, colors, value, onChange }: ColorSwatchRowProps) {
    return (
        <div className="flex flex-col gap-2">
            <label className="text-[11px] font-medium uppercase tracking-[0.05em] text-muted">
                {label}
            </label>
            <div className="flex flex-wrap gap-2">
                {colors.map((color) => (
                    <button
                        key={color}
                        onClick={() => onChange(color)}
                        className="h-6 w-6 cursor-pointer rounded-full p-0"
                        style={{
                            backgroundColor: color,
                            border:
                                value === color
                                    ? '2px solid var(--color-ink)'
                                    : '0.5px solid var(--color-line)',
                            boxSizing: 'border-box',
                        }}
                        aria-label={`Select color ${color}`}
                    />
                ))}
            </div>
        </div>
    );
}
